import Login from "../Pages/Authentication/Login";
import Home from "../Pages/Home";
import Services from "../Pages/Services";
import ProductRange from "../Pages/ProductRange";
import Events from "../Pages/Events";
import VaultAccess from "../Pages/VaultAccess";
import VaultAccessDetail from "../Pages/VaultAccess/VaultAccessDetail";
import Catalogs from "../Pages/Catalogs";
import AboutUs from "../Pages/AboutUs";
import ContactUs from "../Pages/ContactUs";
import Learn from "../Pages/Learn";
import BlogDetail from "../Pages/Learn/BlogDetail";
import Register from "../Pages/Authentication/Register"
import ForgetPassword from "../Pages/Authentication/ForgetPassword"
import TermsConditions from "../Pages/TermsConditions";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import AddToCart from "../Pages/AddToCart/AddToCart";
import Enquiry from "../Pages/Enquiry/Enquiry";
import EnquiryDetail from "../Pages/Enquiry/EnquiryDetail";
import UserProfile from "#pages/Authentication/user-profile.js";
import ChangePassword from "../Pages/Authentication/Changepassword";
import VerifyMail from "../Pages/VerifyEmail/VerifyMail";

export const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/forget-password", component: <ForgetPassword /> },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/product-range", component: <ProductRange /> },
  { path: "/catalogs", component: <Catalogs /> },
  { path: "/events", component: <Events /> },
  { path: "/services", component: <Services /> },
  { path: "/learn", component: <Learn /> },
  { path: "/vault-access", component: <VaultAccess /> },
  { path: "/learn/blog/:slug", component: <BlogDetail /> },
  { path: "/terms-condition", component: <TermsConditions /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/", component: <Home /> },
];

export const blankRoutes = [
    { path: "/verifyMail", component: <VerifyMail /> }
]

export const authProtectedRoutes = [
    { path: "/vault-access-detail/:style_ID", component: <VaultAccessDetail /> },
    { path: "/add-to-cart", component: <AddToCart /> },
    { path: "/enquiry", component: <Enquiry /> },
    { path: "/enquiry-detail/:ENQUIRY_ID", component: <EnquiryDetail /> },
    { path: "/change-password", component: <ChangePassword /> },
    { path: "/user-profile", component: <UserProfile /> },
];
